/**
 * Environment variable validation - fails fast on missing required config
 * Only validates public Vite env vars (no server-side secrets)
 */

const REQUIRED_ENV_VARS = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_ANON_KEY',
  'VITE_SUPABASE_AVATAR_STORAGE_BUCKET',
] as const;

function validateEnv(): void {
  const missing: string[] = [];

  for (const key of REQUIRED_ENV_VARS) {
    if (!import.meta.env[key]) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    const message = `Missing required environment variables:\n${missing.map(k => `  - ${k}`).join('\n')}\n\nPlease check your .env file and ensure all required variables are set.`;
    console.error(message);

    // Show error in DOM for visibility during development
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:#1a1a2e;color:#ff6b6b;padding:40px;font-family:monospace;font-size:14px;white-space:pre-wrap;z-index:9999;';
    errorDiv.textContent = `⚠️ Configuration Error\n\n${message}`;
    document.body.innerHTML = '';
    document.body.appendChild(errorDiv);

    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
}

// Run validation immediately when this module is imported
validateEnv();

// Export validated config values
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const AVATAR_STORAGE_BUCKET = import.meta.env.VITE_SUPABASE_AVATAR_STORAGE_BUCKET;
